const BARS = Array.from({ length: 20 }).map((_, i) => (Math.random() > 0.5 ? 4: 2));

export default function BarcodeDecor() {
  return (
    <div className="flex h-10 items-stretch gap-1">
      {BARS.map((width, index) => (
        <span key={index} style={{ width, background:"black"}}/>
      ))}
    </div>
    /*constant unchanging order, rendering, index is fine*/
  );
}
